import {h, Fragment} from "preact"
import { useCurrencyFormatting } from "@nosto/preact"
import { useMemo } from "preact/hooks"

export default function QuickShop({ product, relatedProducts, isMobile }) {

    const isGiftCard = product.categories.includes('Gift Cards')

    function nsAddToCart(e, isMobile){
        let x = e.target.getAttribute('data-id');
        let variant = e.target.closest(".quick-shop-wrapper").querySelector('.quick-shop-select[data-id="'+x+'"]').value;
        let submitButton = e.target;
        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('loading');
        addToCart(variant,1,submitButton)
        setTimeout(() => {
            submitButton.classList.remove('loading');
            if(isMobile){
                e.target.closest(".quick-shop-wrapper")?.querySelector(".quick-shop-close")?.click();
            }
        }, 350);
    }

    function dialogClicked(e) {
        e.preventDefault();
        if(e.target.tagName ==="DIALOG" && e.target.hasAttribute('open')){
            e.target.closest(".quick-shop-wrapper")?.querySelector(".quick-shop-close")?.click();
        }
        // 
        
    }

    return (
       <>
            {isMobile ? 
                <dialog class="quick-shop-wrapper mobile-quickshop" productId={product.productId} onClick={(e) => dialogClicked(e)}>
                    <div class="quick-shop-inner">
                        <div class="quick-shop-close" onClick={(e) => e.target.closest(".mobile-quickshop").close()}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                focusable="false"
                                role="presentation"
                                class="icon icon-close"
                                fill="none"
                                viewBox="0 0 18 17"
                                width="2rem"
                            >
                                <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="#10212c"></path>
                            </svg>
                        </div>
                        <div class="mobile-quickshop-title">{product.name}</div>
                        <div class="quick-shop-form">
                            <form method="post" action="/cart/add">
                                <select
                                    class="quick-shop-select"
                                    data-id={product.productId}
                                    name="id"
                                    onChange={(e) => e.target.closest(".quick-shop-wrapper")?.querySelector(".quick-shop-add")?.removeAttribute("disabled")}
                                >
                                <option value="choose-size" class="ns-d-block choose-size" selected="">Choose Size</option>
                                {relatedProducts?.length > 1 && relatedProducts?.map((prod) => {
                                    if (prod.productId != product.productId) return;
                                    return(
                                        prod?.skus?.map((sku) => {
                                            return <option productId={prod.productId} value={sku.id} disabled={sku.availability !== "InStock"} style={`${product.productId != prod.productId ? 'display:none' : ''}`}>{sku.name}</option>
                                        })
                                    )
                                })}
                                {relatedProducts?.length < 2 && product.skus?.map((sku) => {
                                    var size = sku.customFields.find(field => field.key == "size")?.value;
                                    var denominations = sku.customFields.find(field => field.key == "denominations")?.value;
                                    if(denominations) {
                                        return <option productId={product.productId} value={sku.id} disabled={!isGiftCard && sku.availability !== "InStock"}>{denominations}</option>
                                    } else {
                                        return <option productId={product.productId} value={sku.id} disabled={!isGiftCard && sku.availability !== "InStock"}>{size}</option>
                                    }
                                })}
                                </select>
                                {relatedProducts?.length > 1 && relatedProducts?.map((prod) => {
                                    if (prod.productId == product.productId) return;
                                    return(
                                        <select
                                            class="quick-shop-select"
                                            data-id={prod.productId}
                                            name="id"
                                            style="display: none;"
                                            onChange={(e) => e.target.closest(".quick-shop-wrapper")?.querySelector(".quick-shop-add")?.removeAttribute("disabled")}
                                        >
                                        <option value="choose-size" class="ns-d-block choose-size" selected="">Choose Size</option>
                                        {prod?.skus?.map((sku) => {
                                            return <option productId={prod.productId} value={sku.id} disabled={sku.availability !== "InStock"}>{sku.name}</option>
                                        })}
                                        </select>
                                    )
                                })}
                                <button
                                    data-id={product.productId}
                                    type="submit"
                                    class="product-form__submit button button--full-width button--secondary quick-shop-add"
                                    disabled
                                    onClick={(e) => { nsAddToCart(e, isMobile) }}
                                >
                                    Add to bag
                                </button>
                            </form>
                        </div>
                        <div className="ns-mobile-spacer"></div>
                    </div>
                </dialog>
                :
                <div class="quick-shop-wrapper" onClick={(e) => e.preventDefault()}>
                    <div class="quick-shop-close" onClick={(e) => e.target.closest(".quick-shop-wrapper").classList.remove("ns-d-block")}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                            focusable="false"
                            role="presentation"
                            class="icon icon-close"
                            fill="none"
                            viewBox="0 0 18 17"
                            width="2rem"
                        >
                            <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="#10212c"></path>
                        </svg>
                    </div>
                    <div class="quick-shop-form">
                        <form method="post" action="/cart/add">
                            <select
                                class="quick-shop-select"
                                data-id={product.productId}
                                name="id"
                                onChange={(e) => e.target.closest(".quick-shop-wrapper")?.querySelector(".quick-shop-add")?.removeAttribute("disabled")}
                            >
                            <option value="choose-size" class="ns-d-block choose-size" selected="">Choose Size</option>
                            {relatedProducts?.length > 1 && relatedProducts?.map((prod) => {
                                if (prod.productId != product.productId) return;
                                return(
                                    prod?.skus?.map((sku) => {
                                        return <option productId={prod.productId} value={sku.id} disabled={sku.availability !== "InStock"} style={`${product.productId != prod.productId ? 'display:none' : ''}`}>{sku.name}</option>
                                    })
                                )
                            })}
                            {relatedProducts?.length <= 1 && product.skus?.map((sku) => {
                                var size = sku.customFields.find(field => field.key == "size")?.value;
                                var denominations = sku.customFields.find(field => field.key == "denominations")?.value;
                                if (denominations) {
                                    return <option productId={product.productId} value={sku.id} disabled={!isGiftCard && sku.availability !== "InStock"}>{denominations}</option>
                                } else {
                                    return <option productId={product.productId} value={sku.id} disabled={!isGiftCard && sku.availability !== "InStock"}>{size}</option>
                                }
                            })}
                            </select>
                            {relatedProducts?.length > 1 && relatedProducts?.map((prod) => {
                                if (prod.productId == product.productId) return;
                                return(
                                    <select
                                        class="quick-shop-select"
                                        data-id={prod.productId}
                                        name="id"
                                        style="display: none;"
                                        onChange={(e) => e.target.closest(".quick-shop-wrapper")?.querySelector(".quick-shop-add")?.removeAttribute("disabled")}
                                    >
                                    <option value="choose-size" class="ns-d-block choose-size" selected="">Choose Size</option>
                                    {prod?.skus?.map((sku) => {
                                        return <option productId={prod.productId} value={sku.id} disabled={sku.availability !== "InStock"}>{sku.name}</option>
                                    })}
                                    </select>
                                )
                            })}
                            <button
                                data-id={product.productId}
                                type="submit"
                                class="product-form__submit button button--full-width button--secondary quick-shop-add"
                                disabled
                                onClick={(e) => { nsAddToCart(e, isMobile) }}
                            >
                                Add to bag
                            </button>
                        </form>
                    </div>
                </div>
            }
        </>
    )
}
